require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// /~/babel-runtime/~/core-js/library/fn/object/assign.js
// module id = 833
// module chunks = 31